import type { PosMessages } from "./messages.en";

export const posEs: Partial<Record<keyof PosMessages, string>> = {
  "pos.inventory.title": "Recepción de inventario",
  "pos.jonas.queue.pending": "Requiere revisión",
  "pos.jonas.queue.confirmed": "Configuración confirmada",
  "pos.jonas.queue.blocked": "Marcadores de eliminación conservados",
  "pos.jonas.queue.all": "Todos los artículos importados",
  "pos.suppliers.title": "Revisión de proveedores de Jonas",
  "pos.suppliers.help": "Vincule un código de proveedor solo después de confirmar el proveedor correcto. Los artículos siguen archivados y no se cambian precios, existencias ni impresión.",
  "pos.suppliers.missing": "{count} registros no tienen código de proveedor y requieren evidencia individual.",
  "pos.suppliers.code": "Código de proveedor sin vincular",
  "pos.suppliers.search": "Buscar proveedores activos (primeras 50 coincidencias)",
  "pos.suppliers.vendor": "Proveedor confirmado",
  "pos.suppliers.preview": "Vista previa de vínculos",
  "pos.suppliers.records": "Se vincularán {count} registros exactos de origen.",
  "pos.suppliers.ack": "He verificado que este código de Jonas corresponde al proveedor seleccionado.",
  "pos.suppliers.apply": "Aplicar vínculos revisados",
  "pos.suppliers.saved": "Vínculos guardados. Los precios y el estado de venta no han cambiado.",

  "pos.jonas.comparePrices": "Comparar precios de Jonas",
  "pos.jonas.priceSafety": "Solo comparación de origen. Los artículos siguen archivados; no se activan precios ni impresión.",
  "pos.jonas.priceOrigins": "El precio regular procede del catálogo de ventas; socio y minorista, del inventario vinculado. Los valores vacíos o cero no son precios gratuitos aprobados. Los cambios programados se muestran por separado.",
  "pos.jonas.onlyDifferences": "Mostrar solo precios positivos diferentes",
  "pos.jonas.priceTotals": "{total} artículos vinculados; {paired} tienen orígenes de ventas e inventario.",
  "pos.jonas.pricePairs": "Socio frente a minorista: {equal} iguales, {different} diferentes. Regular frente a minorista: {regularDifferent} diferentes. Solo se comparan precios positivos.",
  "pos.jonas.regularPrice": "Regular (ventas)",
  "pos.jonas.memberPrice": "Socio (inventario)",
  "pos.jonas.retailPrice": "Minorista (inventario)",
  "pos.jonas.scheduledPrices": "Valores y fechas programados de origen",
  "pos.jonas.priceState.positive": "Valor de origen positivo",
  "pos.jonas.priceState.zero": "Cero: requiere revisión",
  "pos.jonas.priceState.negative": "Negativo: requiere revisión",
  "pos.jonas.priceState.blank": "Vacío en origen",
  "pos.jonas.priceState.not_applicable": "Sin origen vinculado de este tipo",
  "pos.jonas.priceState.missing_field": "Campo ausente en origen",
  "pos.jonas.priceState.ambiguous": "Valores de origen ambiguos",
  "pos.jonas.priceState.invalid": "Precio no válido",
  "pos.jonas.suppliers": "Proveedores de Jonas vinculados",
  "pos.jonas.saleReview": "Artículos importados por revisar",
  "pos.jonas.saleReviewHelp": "Estos artículos no están a la venta. Revise el origen, edite y confirme la configuración de venta, elija una categoría activa y establezca precios antes de restaurarlos.",
  "pos.jonas.confirmSettings": "He revisado y confirmo esta configuración de venta",
  "pos.jonas.reviewConfirmed": "Configuración de venta confirmada",
  "pos.jonas.previousReviews": "50 artículos anteriores",
  "pos.jonas.nextReviews": "50 artículos siguientes",
  "pos.jonas.retained": "Origen conservado para revisión",
  "pos.jonas.title": "Revisión del catálogo de Jonas",
  "pos.jonas.subtitle": "Revise artículos y SKU importados y prepare borradores de POS vinculados.",
  "pos.jonas.safety": "Los registros originales se conservan. Los borradores quedan archivados, sin precios, cantidades, pedidos ni impresión. Revise sus ajustes y precios antes de ponerlos a la venta.",
  "pos.jonas.empty": "No se han importado catálogos de Jonas para este club.",
  "pos.jonas.dataset": "Captura de origen",
  "pos.jonas.search": "Buscar nombres, códigos o códigos de barras importados",
  "pos.jonas.complete": "Origen completo: {rows} de {expected} registros",
  "pos.jonas.incomplete": "Origen incompleto: {rows} de {expected}. No se pueden crear borradores.",
  "pos.jonas.linkedCount": "{count} vinculados a artículos de POS",
  "pos.jonas.noRecords": "No hay registros coincidentes.",
  "pos.jonas.code": "Código de origen",
  "pos.jonas.review": "Estado de revisión",
  "pos.jonas.missing": "Sin datos",
  "pos.jonas.openItem": "Abrir artículo de POS vinculado",
  "pos.jonas.createDraft": "Crear borrador de POS vinculado",
  "pos.jonas.draftHint": "Elija tipo, impuesto, servicio y consumo mínimo. No se deducen precios ni estado activo de Jonas. El borrador se abre en el editor para revisarlo.",
  "pos.jonas.choose": "Elegir…",
  "pos.jonas.standard": "Estándar",
  "pos.jonas.exempt": "Exento",
  "pos.jonas.required": "Escriba un nombre y elija tipo, impuesto, servicio y mínimo.",
  "pos.jonas.back": "Volver a la revisión del catálogo",
  "pos.jonas.sourceDetails": "Detalles de origen",
  "pos.jonas.prices": "Precios de referencia",
  "pos.jonas.priceHint": "Solo se muestran precios positivos como referencia. Los precios futuros, de socios y habituales pueden tener significados diferentes. Los valores vacíos, cero, negativos o inválidos no son precios de venta. Configure precios por punto de venta en el editor.",
  "pos.jonas.noPrice": "Sin precio positivo válido",
  "pos.jonas.related": "Registros de ventas y SKU relacionados",
  "pos.jonas.truncated": "Se muestran los primeros 50 registros. Busque en la captura para ver todos.",
  "pos.jonas.fields": "Campos originales",
  "pos.jonas.showEmpty": "Mostrar también campos vacíos",
  "pos.jonas.position": "Posición",
  "pos.jonas.field": "Campo de origen",
  "pos.jonas.value": "Valor original",
  "pos.jonas.source.items": "Artículos de venta",
  "pos.jonas.source.retail": "SKU minoristas",
  "pos.jonas.source.categories": "Categorías de venta",
  "pos.jonas.source.areas": "Áreas de venta",
  "pos.jonas.issue.missing_code": "Revisar código",
  "pos.jonas.issue.missing_name": "Revisar nombre",
  "pos.jonas.issue.no_positive_price": "Sin precio positivo confirmado",
  "pos.jonas.issue.status_unconfirmed": "Estado activo sin confirmar",
  "pos.jonas.issue.missing_pos_reference": "Sin referencia de artículo de venta",
  "pos.jonas.issue.ambiguous_fields": "Revisar campos clave repetidos",
  "pos.jonas.related.available": "Se muestran referencias exactas. No se fusionan automáticamente artículos, variantes, proveedores ni existencias.",
  "pos.jonas.related.not_found": "No hay una referencia exacta en el origen disponible.",
  "pos.jonas.related.missing_reference": "El origen no identifica un artículo de venta.",
  "pos.jonas.related.source_incomplete": "El origen relacionado no se ha importado completamente.",
  "pos.jonas.related.ambiguous_source": "Hay varias versiones con la misma fecha. Resuelva la versión antes de vincular.",
  "pos.jonas.related.ambiguous_fields": "Hay campos de referencia repetidos. No se pueden vincular con certeza.",
  "pos.jonas.related.not_applicable": "Este origen es una categoría o área de venta.",

  "pos.register.backToClub": "Volver a ClubCore",
  "pos.barcode.download": "Descargar etiqueta",
  "pos.barcode.generate": "Generar código de barras",
  "pos.register.fullscreen": "Pantalla completa",
  "pos.register.windowed": "Ventana",
  "pos.register.fullscreenFailed": "La pantalla completa no está disponible.",
  "pos.register.scannerBusy": "La caja está ocupada. Escanee de nuevo cuando esté lista.",
  "pos.register.scannerHint": "Escáner USB/Bluetooth listo. Escanee fuera de un campo de texto o ingrese el código aquí.",

  // Palabras comunes
  "pos.actions": "Acciones",
  "pos.field.name": "Nombre",
  "pos.field.description": "Descripción",
  "pos.field.type": "Tipo",
  "pos.field.category": "Categoría",
  "pos.field.noCategory": "Sin categoría",
  "pos.field.photo": "Foto",
  "pos.field.sku": "SKU",
  "pos.field.skus": "SKU",
  "pos.field.skuHint": "Solo letras, dígitos y - . / _ . Déjelo vacío si no tiene.",
  "pos.field.barcode": "Código de barras",
  "pos.field.taxTreatment": "Impuesto",
  "pos.field.serviceCharge": "Cargo por servicio",
  "pos.field.countsTowardMinimum": "Cuenta para el mínimo de comida y bebida",
  "pos.field.countsHint": "Solo cuenta si el departamento del punto de venta también cuenta.",
  "pos.field.showInMemberApp": "Mostrar en la app para socios",
  "pos.field.sortOrder": "Orden",
  "pos.field.wholeNumber": "Escriba un número entero.",
  "pos.type.retail": "Tienda",
  "pos.type.food": "Comida",
  "pos.type.beverage": "Bebida",
  "pos.type.service": "Servicio",
  "pos.treatment.standard": "Normal",
  "pos.treatment.exempt": "Exento",
  "pos.outletType.dining": "Comedor",
  "pos.outletType.bar": "Bar",
  "pos.outletType.pro_shop": "Tienda de golf",
  "pos.outletType.catering": "Banquetes",
  "pos.outletType.room_service": "Servicio a la habitación",
  "pos.outletType.other": "Otro",
  "pos.status.active": "Activo",
  "pos.status.archived": "Archivado",
  "pos.active.on": "Sí",
  "pos.active.off": "No",
  "pos.price.notSold": "No se vende aquí",
  "pos.price.range": "de {from} a {to}",
  "pos.rule.optionalAny": "Opcional, cualquier cantidad",
  "pos.rule.optionalUpto": "Opcional, hasta {max}",
  "pos.rule.exactly": "Elegir exactamente {count}",
  "pos.rule.between": "Elegir de {min} a {max}",
  "pos.rule.atLeast": "Elegir al menos {min}",

  // Lista de artículos
  "pos.items.title": "Artículos",
  "pos.items.subtitle": "Todo lo que vende el club: qué es, dónde se vende y a qué precio.",
  "pos.items.new": "Nuevo artículo",
  "pos.items.search": "Buscar artículos",
  "pos.items.searchPlaceholder": "Nombre, SKU o código de barras",
  "pos.items.anyType": "Cualquier tipo",
  "pos.items.anyCategory": "Cualquier categoría",
  "pos.items.status": "Estado",
  "pos.items.status.active": "Activos",
  "pos.items.status.archived": "Archivados",
  "pos.items.status.all": "Activos y archivados",
  "pos.items.memberAppOnly": "Mostrados en la app para socios",
  "pos.items.priceAt": "Mostrar precio en",
  "pos.items.noOutlet": "Ningún punto de venta",
  "pos.items.priceToday": "Precio de hoy",
  "pos.items.moreSkus": "+{more}",
  "pos.items.empty": "Todavía no hay artículos",
  "pos.items.emptyBody": "Agregue el primer artículo para iniciar el catálogo. Los artículos archivados se muestran con el filtro Estado.",
  "pos.items.noMatch": "Ningún artículo coincide con estos filtros",
  "pos.items.noMatchBody": "Cambie o borre la búsqueda y los filtros para ver más.",

  // Nuevo artículo
  "pos.item.newTitle": "Nuevo artículo",
  "pos.item.add": "Agregar artículo",
  "pos.item.created": "Se agregó {name}.",
  "pos.item.nameRequired": "Escriba un nombre.",
  "pos.item.variantNamesRequired": "Póngale nombre a cada variante.",
  "pos.item.startWithVariants": "Empezar con varias variantes",
  "pos.item.addAnotherVariant": "Agregar otra variante",
  "pos.item.variantNameN": "Nombre de la variante {number}",
  "pos.item.removeVariantN": "Quitar la variante {number}",

  // Página del artículo
  "pos.item.title": "Artículo",
  "pos.item.back": "Todos los artículos",
  "pos.item.archive": "Archivar",
  "pos.item.restore": "Restaurar",
  "pos.item.archived": "Se archivó {name}.",
  "pos.item.restored": "Se restauró {name}.",
  "pos.item.details": "Detalles",
  "pos.item.saved": "Se guardó {name}.",
  "pos.item.nothingToSave": "No hay cambios.",
  "pos.item.variants": "Variantes",

  // Foto
  "pos.photo.title": "Foto",
  "pos.photo.none": "Todavía no hay foto.",
  "pos.photo.add": "Agregar foto",
  "pos.photo.replace": "Reemplazar foto",
  "pos.photo.remove": "Quitar foto",
  "pos.photo.choose": "Elegir un archivo de foto",
  "pos.photo.saved": "Foto guardada.",
  "pos.photo.removed": "Foto quitada.",
  "pos.photo.removeTitle": "¿Quitar esta foto?",
  "pos.photo.removeBody": "La foto de {name} se elimina de ClubCore. No se conserva el archivo original.",
  "pos.photo.notImage": "Elija un archivo de imagen (JPEG, PNG, WebP, GIF, BMP, TIFF o AVIF).",
  "pos.photo.tooLarge": "Ese archivo pesa más de 15 MB.",

  // Variantes
  "pos.variant.add": "Agregar variante",
  "pos.variant.addTitle": "Agregar una variante",
  "pos.variant.addRenameHint": "Este artículo tiene una variante sin nombre. Ahora las dos variantes necesitan nombre.",
  "pos.variant.renameExisting": "Nombre de la variante existente",
  "pos.variant.newName": "Nombre de la variante nueva",
  "pos.variant.added": "Se agregó {name}.",
  "pos.variant.editN": "Editar la variante {name}",
  "pos.variant.editTitle": "Editar variante",
  "pos.variant.saved": "Variante guardada.",
  "pos.variant.options": "Opciones",
  "pos.variant.optionsHint": "Una por línea, escrita como nombre: valor (por ejemplo Talla: Grande).",
  "pos.variant.optionsBad": "Escriba cada opción como nombre: valor. Esta línea no lo está: {line}",
  "pos.variant.active": "Activa",
  "pos.variant.activeLabel": "Activa (se puede vender)",
  "pos.variant.unnamed": "(sin nombre)",
  "pos.variant.nameRequired": "Escriba un nombre.",
  "pos.variant.renameRequired": "Escriba un nombre para la variante existente.",
  "pos.variant.singleOnly": "Solo los artículos de tienda pueden tener varias variantes. La comida y las bebidas usan grupos de opciones para sus alternativas.",

  // Grupos de opciones de un artículo
  "pos.modifiers.title": "Grupos de opciones",
  "pos.modifiers.none": "Este artículo no pide ningún grupo de opciones.",
  "pos.modifiers.pick": "Agregar un grupo",
  "pos.modifiers.choose": "Elija un grupo",
  "pos.modifiers.noneLeft": "No hay más grupos",
  "pos.modifiers.add": "Agregar grupo",
  "pos.modifiers.added": "Se agregó {name} al artículo.",
  "pos.modifiers.removed": "Se quitó {name} del artículo.",
  "pos.modifiers.moved": "Se movió {name}.",
  "pos.modifiers.up": "Subir",
  "pos.modifiers.down": "Bajar",
  "pos.modifiers.moveUpN": "Subir {name}",
  "pos.modifiers.moveDownN": "Bajar {name}",
  "pos.modifiers.removeN": "Quitar {name}",

  // Precios
  "pos.prices.title": "Precios",
  "pos.prices.noOutlets": "El club todavía no tiene puntos de venta, así que no hay dónde fijar un precio.",
  "pos.prices.outlet": "Punto de venta",
  "pos.prices.variant": "Variante",
  "pos.prices.today": "Precio de hoy",
  "pos.prices.next": "Próximo cambio",
  "pos.prices.noPrice": "Sin precio",
  "pos.prices.changesTo": "{price} desde el {date}",
  "pos.prices.stopsFrom": "Deja de venderse desde el {date}",
  "pos.prices.set": "Fijar precio",
  "pos.prices.setFor": "Fijar precio en {outlet} {variant}",
  "pos.prices.setTitle": "Fijar un precio para {name}",
  "pos.prices.save": "Guardar precio",
  "pos.prices.saved": "Precio guardado.",
  "pos.prices.stopSaved": "Dejará de venderse en esa fecha.",
  "pos.prices.chooseOutlet": "Elija un punto de venta",
  "pos.prices.outletRequired": "Elija un punto de venta.",
  "pos.prices.allVariants": "Todas las variantes",
  "pos.prices.amount": "Precio",
  "pos.prices.amountHint": "En dólares, por ejemplo {example}.",
  "pos.prices.amountInvalid": "Escriba un precio como {example}, con dos decimales como máximo.",
  "pos.prices.starts": "Empieza",
  "pos.prices.dateRequired": "Elija la fecha en que empieza el precio.",
  "pos.prices.stopSelling": "Dejar de vender aquí desde esta fecha",
  "pos.prices.stopSellingHint": "El artículo sale del menú de este punto de venta desde esa fecha.",
  "pos.prices.upcoming": "Precios que todavía no empiezan",
  "pos.prices.upcomingPrice": "{price} desde el {date}",
  "pos.prices.removeFor": "Quitar el precio de {outlet} desde el {date}",
  "pos.prices.removed": "Precio quitado.",

  // Categorías
  "pos.categories.title": "Categorías",
  "pos.categories.subtitle": "Cómo se agrupan los artículos para vender y para los informes. Dos niveles como máximo.",
  "pos.categories.new": "Nueva categoría",
  "pos.categories.newTitle": "Nueva categoría",
  "pos.categories.editTitle": "Editar categoría",
  "pos.categories.add": "Agregar categoría",
  "pos.categories.code": "Código",
  "pos.categories.codeHint": "Letras minúsculas, dígitos y - . _ , hasta 32.",
  "pos.categories.codeRequired": "Escriba un código.",
  "pos.categories.nameRequired": "Escriba un nombre.",
  "pos.categories.parent": "Dentro de",
  "pos.categories.topLevel": "Nivel superior",
  "pos.categories.itemCount": "Artículos activos",
  "pos.categories.editN": "Editar {name}",
  "pos.categories.switchOff": "Desactivar",
  "pos.categories.switchOn": "Activar",
  "pos.categories.switchOffN": "Desactivar {name}",
  "pos.categories.switchOnN": "Activar {name}",
  "pos.categories.switchedOff": "Se desactivó {name}. Sus artículos salen de los menús.",
  "pos.categories.switchedOn": "Se activó {name}.",
  "pos.categories.created": "Se agregó {name}.",
  "pos.categories.saved": "Se guardó {name}.",
  "pos.categories.empty": "Todavía no hay categorías",
  "pos.categories.emptyBody": "Agregue una categoría para empezar a agrupar artículos.",

  // Grupos de opciones
  "pos.groups.title": "Grupos de opciones",
  "pos.groups.subtitle": "Conjuntos de alternativas, como el término de la carne o los acompañamientos, que comparten los artículos de comida, bebida y servicio.",
  "pos.groups.new": "Nuevo grupo",
  "pos.groups.search": "Buscar grupos",
  "pos.groups.show.active": "Activos",
  "pos.groups.show.off": "Desactivados",
  "pos.groups.show.all": "Todos",
  "pos.groups.rule": "Regla",
  "pos.groups.itemCount": "Artículos",
  "pos.groups.editN": "Editar {name}",
  "pos.groups.empty": "Todavía no hay grupos de opciones",
  "pos.groups.emptyBody": "Agregue un grupo para dar alternativas a los artículos de comida y bebida.",
  "pos.groups.noMatch": "Ningún grupo coincide con estos filtros",
  "pos.groups.noMatchBody": "Cambie o borre la búsqueda y el filtro para ver más.",
  "pos.group.newTitle": "Nuevo grupo de opciones",
  "pos.group.editTitle": "Editar grupo de opciones",
  "pos.group.add": "Agregar grupo",
  "pos.group.created": "Se agregó {name}.",
  "pos.group.saved": "Se guardó {name}.",
  "pos.group.nameRequired": "Escriba un nombre.",
  "pos.group.min": "Mínimo a elegir",
  "pos.group.minHint": "1 o más hace obligatoria la elección.",
  "pos.group.minInvalid": "Escriba 0 o un número entero mayor.",
  "pos.group.max": "Máximo a elegir",
  "pos.group.maxHint": "Déjelo vacío para cualquier cantidad.",
  "pos.group.maxInvalid": "Escriba un número entero de 1 o más, o déjelo vacío.",
  "pos.group.activeLabel": "El grupo está activo",
  "pos.group.choices": "Opciones",
  "pos.group.noChoices": "Todavía no hay opciones.",
  "pos.group.choiceN": "Opción {number}",
  "pos.group.choiceName": "Nombre de la opción",
  "pos.group.choiceNameRequired": "Escriba un nombre para esta opción.",
  "pos.group.priceChange": "Cambio de precio",
  "pos.group.priceHint": "Se suma al precio del artículo. Déjelo vacío si no hay; un signo menos descuenta.",
  "pos.group.priceInvalid": "Escriba un monto como {example}, con dos decimales como máximo.",
  "pos.group.preselected": "Preseleccionada",
  "pos.group.choiceActive": "Activa",
  "pos.group.addChoice": "Agregar una opción",
  "pos.group.discardChoice": "Descartar esta opción",

  // Puntos de venta
  "pos.outlets.title": "Puntos de venta",
  "pos.outlets.subtitle": "Los lugares desde donde vende el club. Cada uno pertenece a un departamento de facturación; los ingresos y el impuesto lo siguen.",
  "pos.outlets.department": "Departamento",
  "pos.outlets.menu": "Menú",
  "pos.outlets.menuN": "Menú de {name}",
  "pos.outlets.editN": "Editar {name}",
  "pos.outlets.editTitle": "Editar punto de venta",
  "pos.outlets.nameRequired": "Escriba un nombre.",
  "pos.outlets.saved": "Se guardó {name}.",
  "pos.outlets.empty": "Todavía no hay puntos de venta",
  "pos.outlets.emptyBody": "Aquí aparecen los puntos de venta del club.",
  "pos.outlets.departmentHint": "Los ingresos y el impuesto siguen al departamento.",
  "pos.outlets.departmentFixed": "Departamento: {name}.",
  "pos.outlets.departmentsUnavailable": "La lista de departamentos requiere acceso a facturación, así que no se puede cambiar aquí.",
  "pos.outlets.activeLabel": "El punto de venta está activo",
  "pos.outlets.activeHint": "Un punto de venta desactivado no tiene menú.",

  // Menú del punto de venta
  "pos.menu.title": "Menú del punto de venta",
  "pos.menu.titleFor": "Menú de {name}",
  "pos.menu.subtitle": "Lo que mostraría una terminal.",
  "pos.menu.asOf": "Al {date}",
  "pos.menu.back": "Todos los puntos de venta",
  "pos.menu.date": "Mostrar el menú del día",
  "pos.menu.dateHint": "Déjelo vacío para hoy en el club.",
  "pos.menu.memberAppOnly": "Solo artículos de la app para socios",
  "pos.menu.noCategory": "Sin categoría",
  "pos.menu.required": "Obligatorio",
  "pos.menu.empty": "No hay nada a la venta aquí en esta fecha",
  "pos.menu.emptyBody": "Un artículo aparece cuando está activo y tiene precio en este punto de venta ese día.",
  "pos.menu.emptyMemberApp": "Ningún artículo mostrado en la app para socios está a la venta aquí en esta fecha.",

  // Códigos de error del servidor
  "apiError.price_in_past": "Un precio no puede empezar en una fecha que ya pasó. Elija hoy o una fecha posterior.",
  "apiError.price_too_far_ahead": "Un precio no puede empezar a más de tres años de hoy.",
  "apiError.price_in_effect": "Solo se puede quitar un precio que empieza en el futuro. Fije un precio nuevo desde una fecha.",
  "apiError.price_not_found": "Ese precio ya no existe.",
  "apiError.category_too_deep": "Las categorías tienen dos niveles como máximo: una categoría con subcategorías no puede ir dentro de otra, y una subcategoría no puede contener otras.",
  "apiError.category_cycle": "Una categoría no puede ir dentro de sí misma.",
  "apiError.category_code_taken": "Ya existe una categoría con este código.",
  "apiError.outlet_code_taken": "Ya existe un punto de venta con este código.",
  "apiError.outlet_inactive": "Este punto de venta está desactivado, por eso no tiene menú.",
  "apiError.outlet_not_found": "Ese punto de venta ya no existe.",
  "apiError.department_not_found": "Ese departamento ya no existe.",
  "apiError.variant_not_found": "Esa variante ya no existe.",
  "apiError.variants_retail_only": "Solo los artículos de tienda pueden tener más de una variante. La comida y las bebidas usan grupos de opciones para sus alternativas.",
  "apiError.variant_name_required": "Cada variante necesita un nombre cuando el artículo tiene varias.",
  "apiError.variant_name_taken": "Dos variantes no pueden tener el mismo nombre.",
  "apiError.sku_taken": "Otra variante ya usa ese SKU.",
  "apiError.barcode_taken": "Otra variante ya usa ese código de barras.",
  "apiError.sku_with_variants": "Ponga el SKU y el código de barras en cada variante, no en el artículo.",
  "apiError.modifiers_not_for_retail": "Los artículos de tienda no pueden pedir grupos de opciones.",
  "apiError.modifier_group_not_found": "Ese grupo de opciones ya no existe.",
  "apiError.modifier_not_found": "Esa opción ya no existe.",
  "apiError.modifier_group_name_taken": "Ya existe un grupo de opciones con este nombre.",
  "apiError.modifier_name_taken": "Dos opciones de un grupo no pueden tener el mismo nombre.",
  "apiError.not_enough_choices": "El grupo necesita más opciones activas que el mínimo a elegir.",
  "apiError.invalid_selection_range": "El máximo a elegir no puede ser menor que el mínimo.",
  "apiError.too_many_defaults": "Hay más opciones preseleccionadas de las que permite el máximo a elegir.",
  "apiError.duplicate_group": "Un grupo solo puede estar una vez en un artículo.",
  "apiError.code_not_found": "Ningún artículo tiene ese SKU o código de barras.",
  "apiError.photo_not_found": "Este artículo no tiene foto.",
  "apiError.photo_not_an_image": "Ese archivo no es una imagen que ClubCore pueda leer. Use JPEG, PNG, WebP, GIF, BMP, TIFF o AVIF.",
  "apiError.photo_empty": "Ese archivo está vacío.",
  "apiError.photo_damaged": "Esa imagen está dañada y no se puede leer.",
  "apiError.photo_too_many_pixels": "Esa imagen tiene demasiados píxeles. Use una más pequeña.",
  "apiError.photo_heic": "No se admiten imágenes HEIC. Exporte la imagen como JPEG primero.",
  "apiError.photo_too_large": "Ese archivo pesa más de 15 MB.",
};
